import { Remit } from '@portal/models/reducers';

function parseTransactionRule(rule: Remit[]) {
  return rule.map((item) => {
    return {
      min: item.minLimit,
      max: item.maxLimit,
      approvers_group: item.approvers.map((item) => item.value),
      min_approver: Number(item.minApprovers),
    };
  });
}

export default parseTransactionRule;
